'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _traverse = require('./traverse');

var _traverse2 = _interopRequireDefault(_traverse);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function placeTreeAtLoc(node, loc) {
  if (loc) {
    (0, _traverse2.default)(node, function (visited) {
      if (!visited.loc) return Object.assign(visited, loc);
    });
  }return node;
};


//////////////////
// WEBPACK FOOTER
// ../~/ast-loc-utils/lib/placeTreeAtLocWhenUnplaced.js
// module id = 993
// module chunks = 0